<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from '@/shared/mixins/storeGenerator';
const STORE_MODULE_NAME = 'PaymentJournalModule';

export default {
  name: 'JournalPaymentWrapper',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
